module.exports = __webpack_public_path__ + "static/mercado_livre-18bfb0a4ad18974aec7c6801ff380de6.png";